import React from 'react';
import PropTypes from 'prop-types';
import { css, cx } from 'linaria';
import { getImageCacheUrl } from 'common/utilities';
import { breakpointTinyTablet, breakpointMediumTablet, breakpointLargeHandset } from '@pocket/web-ui';
import VisibilitySensor from 'components/visibility-sensor/visibility-sensor';
import { darkMode, sepiaMode } from '@pocket/web-ui';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
const pocketRecsStyles = "p1xcj0ao";
const headingStyles = "hg7pj4a";

const Heading = () => {
  const {
    t
  } = useTranslation();
  return <h3 className={cx('h6', headingStyles)} data-cy="pocket-recs-heading">
      {t('discover:more-stories-from-pocket', 'More Stories from Pocket')}
    </h3>;
};

const publisherStyles = "p8amcx3";
export const Publisher = ({
  name,
  logo
}) => <div className={publisherStyles}>
    {logo ? <img src={logo} data-cy="pocket-rec-publisher-logo" alt={`Logo for ${name}`} /> : <span data-cy="pocket-rec-publisher-name">{name}</span>}
  </div>;
const recommendationStyles = "r1edkw93";
const recommendationsStyles = "r1mn9z7p";
export const Recommendation = ({
  rec,
  position,
  handleRecImpression,
  handleRecClick
}) => {
  if (!rec) return null;
  const {
    title,
    slug,
    topImageUrl,
    publisher,
    resolvedItem
  } = rec;
  const {
    logoWideBwUrl,
    name
  } = publisher;
  const url = `/explore/item/${slug}`;
  const thumbnailUrl = getImageCacheUrl(topImageUrl, {
    width: 270,
    height: 150
  });

  function handleVisible() {
    handleRecImpression({
      resolvedId: resolvedItem.resolvedId,
      position
    });
  }

  function handleClick(e) {
    e.preventDefault();
    handleRecClick({
      resolvedId: resolvedItem.resolvedId,
      position
    }); // timeout ensures analytics event completes

    setTimeout(() => document.location.href = url, 250);
  }

  return <VisibilitySensor onVisible={handleVisible}>
      <li className={recommendationStyles} data-cy="pocket-recommended-article">
        <Link href={url}>
          <a className="thumbnail" onClick={handleClick}>
            <img src={thumbnailUrl} alt={`Logo for ${name}`} />
          </a>
        </Link>
        <div className="details">
          <Publisher name={name} logo={logoWideBwUrl} />
          <Link href={url}>
            <a onClick={handleClick}>
              <h4 className="h5">{title}</h4>
            </a>
          </Link>
        </div>
      </li>
    </VisibilitySensor>;
};
export const PocketRecs = ({
  recommendations,
  maxRecommendations,
  handleRecImpression,
  handleRecClick
}) => {
  if (recommendations.length === 0) return null;
  const recsToDisplay = recommendations.slice(0, maxRecommendations);
  return <div className={cx(pocketRecsStyles, 'pocket-recs')}>
      <Heading />
      <ul className={recommendationsStyles} data-cy="pocket-recommended-articles">
        {recsToDisplay.map(({
        syndicated_article
      }, index) => <Recommendation key={syndicated_article?.slug} rec={syndicated_article} position={index} handleRecImpression={handleRecImpression} handleRecClick={handleRecClick} />)}
      </ul>
    </div>;
};
PocketRecs.propTypes = {
  /**
   * A list of recommended articles from the same publisher
   */
  recommendations: PropTypes.arrayOf(PropTypes.object),

  /**
   * The max number of recommended articles to display
   */
  maxRecommendations: PropTypes.number,

  /**
   * Callback function to fire on Rec impression
   */
  handleRecImpression: PropTypes.func,

  /**
   * Callback function to fire on Rec click
   */
  handleRecClick: PropTypes.func
};
PocketRecs.defaultProps = {
  recommendations: [],
  maxRecommendations: 3,
  handleRecImpression: () => {},
  handleRecClick: () => {}
};
export default PocketRecs;

require("../../../.linaria-cache/src/components/pocket-recs/pocket-recs.linaria.module.css");